import search from '@api/search';
import { improveMpPerformanceTier2Selector } from '@redux/experiments/selectors/improve-mp-performance-tier-2';
import { generateExperimentHeader } from '@server/methods/search/utils';
import { getVisitorId } from '@utils/cookies';
import { generateSeed } from '@utils/generateSeed';
import {
	DEI_FILTER_MAP,
	DISTANCE_100_FILTER,
	DISTANCE_FILTERS,
} from '../../utils/filterConstants';

const removeDistanceFilters = (filter) => !DISTANCE_FILTERS.includes(filter);

const buildDeiFilters = (appliedIds) => {
	return DEI_FILTER_MAP.filter((filter) => appliedIds.includes(filter.id));
};

const dedupSupplemental = (supplemental, profiles) => {
	return supplemental.filter(
		(supp) => !profiles.some((item) => item.id === supp.id),
	);
};

export const fetchBase =
	(actionType, options = {}) =>
	async (dispatch, getState) => {
		const seed = options.seed || generateSeed();
		dispatch({
			type: actionType,
			preserveVendors:
				improveMpPerformanceTier2Selector(getState()) === 'variant1',
		});

		try {
			const state = getState();
			const {
				category: { code },
				search: searchState,
				experiments,
			} = state;

			const {
				location: { city, stateCode },
				...searchOptions
			} = options;

			const headers = generateExperimentHeader(experiments);

			const searchResponse = await search(
				{
					...searchOptions,
					categoryCode: code,
					city,
					seed,
					state: stateCode,
					visitorId: getVisitorId(),
					shouldFetchPriceRangeIntervals: Boolean(
						options.shouldFetchPriceRangeIntervals,
					),
				},
				headers,
			);

			const appliedIds = options.filters;
			const deiFilters = buildDeiFilters(appliedIds);
			searchResponse.data.data.search.deiFilters = deiFilters;

			if (deiFilters.length) {
				// If DEI Filter used, do not show API supplementals
				searchResponse.data.data.search.supplemental = [];

				const { profiles } = searchResponse.data.data.search;

				// If not enough vendors returned, increase search radius and apply as supplementals
				if (profiles.length < 6 && !appliedIds.includes(DISTANCE_100_FILTER)) {
					const filters = [
						...options.filters.filter((f) => removeDistanceFilters(f)),
						DISTANCE_100_FILTER,
					];
					const newSearchResponse = await search(
						{
							...searchOptions,
							categoryCode: code,
							city,
							filters,
							seed,
							state: stateCode,
							visitorId: getVisitorId(),
						},
						headers,
					);
					const newProfiles =
						newSearchResponse?.data?.data?.search?.profiles || [];
					searchResponse.data.data.search.supplemental = dedupSupplemental(
						newProfiles,
						profiles,
					);
				}
			}

			dispatch({
				type: `${actionType}_SUCCESS`,
				payload: { ...searchResponse.data, seed },
			});

			return searchResponse;
		} catch (err) {
			dispatch({
				type: `${actionType}_ERROR`,
				payload: { errors: err.data?.errors[0].message || 'Unknown' },
			});

			return err;
		}
	};
